<script>
  import { link } from "svelte-routing";

  const year = new Date().getFullYear();
</script>

<style>
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    margin-bottom: 6px;
  }

  .footer-subtitle {
    font-weight: 600;
    margin-bottom: 10px;
  }

  .footer {
    background-color: unset;
    padding-bottom: 3em;
    border-top: 1px solid #eaeaea;
    margin-top: 40px;
  }

  .logo {
    font-family: montserrat;
    text-transform: uppercase;
    font-weight: 300;
    letter-spacing: -2px;
    color: #333;
    font-size: 24px;
  }
</style>

<div class="container">
  <footer class="footer">
    <div class="columns">
      <div class="column">
        <div class="logo">Bringflow</div>
        © {year} Mavel Systems
      </div>
      <div class="column is-2">
        <div class="footer-subtitle">Actions</div>
        <ul>
          <li><a href="https://app.bringflow.com/register">Sign up</a></li>
          <li><a href="https://app.bringflow.com/login">Log in</a></li>
        </ul>
      </div>
      <div class="column is-2">
        <div class="footer-subtitle">Help</div>
        <ul>
          <li><a href="/privacypolicy" use:link>Privacy policy</a></li>
          <li><a href="/cookies" use:link>Cookies</a></li>
          <li><a href="/terms" use:link>Terms of use</a></li>
          <li><a href="mailto:contact@bringflow.com">Contact</a></li>
        </ul>
      </div>
    </div>
  </footer>
</div>
